<section>
    <h2>Who We Are</h2>
    <p>
        NordNative is a SaaS company focused on automation, sales, and marketing solutions.
    </p>
</section>
<section>
    <h2>What We Do</h2>
    <ul>
        <li>Sales automation: lead capture, pipelines, follow-ups</li>
        <li>Marketing automation: campaigns, email workflows, segmentation</li>
        <li>Analytics: dashboards, attribution, and reporting</li>
    </ul>
</section>
<section>
    <h2>Why Choose Us?</h2>
    <ul>
        <li>Fast onboarding and clear ROI</li>
        <li>Secure, reliable, and scalable</li>
        <li>Built for modern sales and marketing teams</li>
    </ul>
</section>
